import { SxProps, Theme } from '@mui/material';
import { MEDIUM_GRAY } from '../../../styles/GlobalStyles';
import { getMaskedIconStyle } from '../../../services/Utilities';

export const reportNavigationClassNames = {
  backIcon: 'report-navigation-back-icon',
};

export const reportNavigationStyles = {
  container: (theme: Theme) => ({
    position: 'sticky',
    top: 0,
    left: 0,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: MEDIUM_GRAY,
    borderBottom: `1px solid ${theme.palette.divider}`,
    zIndex: 10,
  }) as SxProps<Theme>,

  backButton: (theme: Theme) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1),
  }) as SxProps<Theme>,

  iconButton: (theme: Theme) => ({
    color: theme.palette.text.primary,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  }) as SxProps<Theme>,

  backIcon: () => ({
    display: 'block',
    width: '24px',
    height: '24px',
    backgroundColor: 'currentColor',
    mask: 'var(--report-navigation-icon-url) center / contain no-repeat',
    WebkitMask: 'var(--report-navigation-icon-url) center / contain no-repeat',
  }) as SxProps<Theme>,

  titleContainer: (theme: Theme) => ({
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }) as SxProps<Theme>,

  title: (theme: Theme) => ({
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightMedium,
  }) as SxProps<Theme>,

  spacer: (theme: Theme) => ({
    width: 48,
    padding: theme.spacing(1),
  }) as SxProps<Theme>,
};

export function getReportNavigationIconStyle(src: string) {
  return getMaskedIconStyle('--report-navigation-icon-url', src);
}

export default reportNavigationStyles;
